const comHeader = (() => {

  const header = (document.getElementById("jsHeader") != null);
  if (header) {


    let header = document.getElementById("jsHeader")

    let to = gsap.to(header, {
      scrollTrigger: {
        trigger: 'body',
        start: 'top top',
        end: 'bottom top',
        toggleClass: { targets: header, className: "on" },
        // markers: true,
      }
    });



  }

})()
export default comHeader;